// extracted by mini-css-extract-plugin
export var modalPrice = "index-module--modalPrice--2pNMa";
export var cartButton = "index-module--cartButton--25MGK";
export var addToCartButton = "index-module--addToCartButton--8qQ0m";